<template>
    <div class="bidder-registration-audit">
        <div class="page-header">
            <h2 class="page-title" style="text-align: start;">投标报名审核</h2>
        </div>

        <!-- 搜索条件 -->
        <div class="search-form">
            <el-form :inline="true" :model="searchForm" class="search-form-inline">
                <el-form-item label="项目编号">
                    <el-input v-model="searchForm.projectCode" placeholder="请输入项目编号" clearable
                        style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="searchForm.status" placeholder="请选择审核状态" clearable style="width: 150px">
                        <el-option label="已审核" :value="9"></el-option>
                        <el-option label="提交待审核" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投标人名称">
                    <el-input v-model="searchForm.bidderName" placeholder="请输入投标人名称" clearable
                        style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item label="标段名称">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" clearable
                        style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                    <el-button @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- <el-table-column prop="bidSectionCode" label="标段编号"></el-table-column> -->
            <el-table-column prop="bidSectionName" label="标段名称"></el-table-column>
            <el-table-column prop="bidderName" label="投标单位名称"></el-table-column>
            <el-table-column prop="createTime" label="报名时间"></el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleView(scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
        </div>

        <!-- 详情弹窗 -->
        <el-dialog title="报名资料审核" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false"
            :append-to-body="true">
            <div class="dialog-content">
                <!-- 基本信息 -->
                <div class="detail-info">
                    <h3 class="section-title">基本信息</h3>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">标段编号：</span>
                                <span class="value">{{ detailData.bidSectionCode || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">标段名称：</span>
                                <span class="value">{{ detailData.bidSectionName || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">投标人名称：</span>
                                <span class="value">{{ detailData.bidderName || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">联系人：</span>
                                <span class="value">{{ detailData.relationUser || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">联系电话：</span>
                                <span class="value">{{ detailData.userPhone || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">电子邮箱：</span>
                                <span class="value">{{ detailData.email || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">报名时间：</span>
                                <span class="value">{{ detailData.createTime || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <span class="label">审核状态：</span>
                                <span class="value">
                                    <el-tag v-if="detailData.status === 1" type="warning">待审核</el-tag>
                                    <el-tag v-else-if="detailData.status === 9" type="success">已审核</el-tag>
                                    <el-tag v-else-if="detailData.status === 3" type="danger">已退回</el-tag>
                                    <el-tag v-else type="info">{{ detailData.status }}</el-tag>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="detailData.bidderQualification">
                            <div class="info-item">
                                <span class="label">投标人资格：</span>
                                <span class="value">{{ detailData.bidderQualification }}</span>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="detailData.reason">
                            <div class="info-item">
                                <span class="label">退回原因：</span>
                                <span class="value" style="color: #f56c6c;">{{ detailData.reason }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 报名资料列表 -->
                <div class="document-section" v-if="documentList.length > 0">
                    <h3 class="section-title">报名资料</h3>
                    <el-table :data="documentList" border style="width: 100%">
                        <el-table-column prop="registrationName" label="资料名称" min-width="150"></el-table-column>
                        <el-table-column prop="registrationDescription" label="说明" min-width="200"></el-table-column>
                        <el-table-column label="上传状态" width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.uploadFileId" type="success" size="small">已上传</el-tag>
                                <el-tag v-else type="info" size="small">未上传</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="handlePreview(scope.row)" :disabled="!scope.row.uploadFileId">
                                    <i class="el-icon-view"></i> 预览
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else class="no-data">
                    <el-empty description="暂无报名资料"></el-empty>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
                <el-button type="danger" @click="handleReject" v-if="detailData.status === 1">退回</el-button>
                <el-button type="primary" @click="handleApprove" v-if="detailData.status === 1">审核通过</el-button>
            </div>
        </el-dialog>

        <!-- 退回原因弹窗 -->
        <el-dialog title="退回原因" :visible.sync="rejectDialogVisible" width="400px" :close-on-click-modal="false"
            :append-to-body="true">
            <el-form>
                <el-form-item label="退回原因">
                    <el-input type="textarea" v-model="rejectReason" :rows="4" placeholder="请输入退回原因"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmReject">确认退回</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getBidRegistrationList,
    getBidRegistrationDetail,
    checkBidRegistration
} from '@/api/modules/agent'
import { getFileList, getFileDownloadList } from '@/api/modules/base'

export default {
    name: 'BidderRegistrationAudit',
    data() {
        return {
            bidSectionCode:'',
            // 加载状态
            loading: false,
            // 搜索表单
            searchForm: {
                projectCode: '',
                status: 1,
                bidderName: '',
                bidSectionName: ''
            },
            registrationId:'',// 报名id
            // 分页
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            // 列表数据
            tableData: [],
            // 弹窗显示
            dialogVisible: false,
            rejectDialogVisible: false,
            // 当前选中行
            currentRow: null,
            // 退回原因
            rejectReason: '',
            // 资料列表
            documentList: [],
            // 详情数据
            detailData: {}
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 获取列表数据
        async getList() {
            this.loading = true
            if(!this.searchForm.status){
                this.searchForm.status = 1;
            }
            try {
                const params = {
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                    ...this.searchForm
                }
                const res = await getBidRegistrationList(params)
                if (res.code === 200) {
                    this.tableData = res.data?.list || res.data?.records || res.data || []
                    this.pagination.total = res.data?.total || 0
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            } catch (error) {
                console.error('获取列表失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        // 搜索
        handleSearch() {
            this.pagination.pageNum = 1
            this.getList()
            
        },
        // 重置
        handleReset() {
            this.searchForm = {
                projectCode: '',
                status: '',
                bidderName: '',
                bidSectionName: ''
            }
            this.pagination.pageNum = 1
            this.getList()
        },
        // 每页数量变化
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.pageNum = 1
            this.getList()
        },
        // 页码变化
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getList()
        },
        // 查看详情
        handleView(row) {
            this.currentRow = row
            this.dialogVisible = true
            this.registrationId = row.registrationId
            this.getBidRegistrationDetail(row.registrationId)

        },
        // 获取报名详情
        async getBidRegistrationDetail(registrationId) {
            try {
                const res = await getBidRegistrationDetail(registrationId)
                if (res.code === 200 && res.data) {
                    // 保存详情数据
                    this.detailData = res.data
                    // 保存标段编号
                    this.bidSectionCode = res.data.bidSectionCode
                    // 保存报名资料列表
                    this.documentList = res.data.bidSectionRegistrations || []
                    this.getFileDownloadList()
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            } catch (error) {
                console.error('获取报名详情失败:', error)
                this.$message.error('获取报名详情失败')
            }
        },
        // 预览文件
        handlePreview(row) {
            if (row.uploadFileId) {
                this.getFileDownloadList(row.uploadFileId)
            } else {
                this.$message.info('暂无可预览的文件')
            }
        },

            /**
         * 获取文件下载列表
         */
        async getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                return
            }
            try {
                this.downloadLoading = true
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data && res.data.length > 0) {
                    const firstFile = res.data[0]
                    if (firstFile.fileUrl) {
                        window.open(firstFile.fileUrl, '_blank')
                    } else {
                        this.$message.warning('文件链接不存在')
                    }
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
            } finally {
                this.downloadLoading = false
            }
        },




        // 审核通过
        handleApprove() {
            this.$confirm('确认审核通过该投标人报名申请？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await checkBidRegistration({
                        reason: "",
                        status: 9,
                        registrationId: this.registrationId
                    })
                    if (res.code === 200) {
                        this.$message.success('审核通过')
                        this.dialogVisible = false
                        this.getList()
                    } else {
                        this.$message.error(res.msg || '操作失败')
                    }
                } catch (error) {
                    this.$message.error('操作失败')
                }
            }).catch(() => { })
        },
        // 退回
        handleReject() {
            this.rejectReason = ''
            this.rejectDialogVisible = true
        },
        // 确认退回
        async confirmReject() {
            if (!this.rejectReason.trim()) {
                this.$message.warning('请输入退回原因')
                return
            }
            try {
                const res = await checkBidRegistration({
                    reason: this.rejectReason,
                    status: 3,
                    registrationId: this.registrationId
                })
                if (res.code === 200) {
                    this.$message.success('已退回')
                    this.rejectDialogVisible = false
                    this.dialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (error) {
                this.$message.error('操作失败')
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(bidder-registration-audit);

.dialog-content {
    padding: 10px 0;
}

.dialog-footer {
    text-align: center;
    padding-top: 20px;

    .el-button {
        width: 120px;
        margin: 0 20px;
    }
}

.search-form {
    text-align: start;
}

.pagination-wrapper {
    padding: 20px;
    text-align: right;
}

/* 详情弹窗样式 */
.detail-info {
    margin-bottom: 20px;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 4px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #409EFF;
}

.info-item {
    margin-bottom: 12px;
    line-height: 32px;
    font-size: 14px;
}

.info-item .label {
    color: #606266;
    font-weight: 500;
    display: inline-block;
    min-width: 100px;
}

.info-item .value {
    color: #303133;
}

.document-section {
    margin-top: 20px;
}

.no-data {
    padding: 40px 0;
    text-align: center;
}
</style>

